/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './post-op-recovery.reducer';

export const PostOpRecovery = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const postOpRecoveryList = useAppSelector(state => state.postOpRecovery.entities);
  const loading = useAppSelector(state => state.postOpRecovery.loading);
  const totalItems = useAppSelector(state => state.postOpRecovery.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="post-op-recovery-heading" data-cy="PostOpRecoveryHeading">
        <Translate contentKey="tinyMedicRestApp.postOpRecovery.home.title">Post Op Recoveries</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.postOpRecovery.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/post-op-recovery/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.postOpRecovery.home.createLabel">Create new Post Op Recovery</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.postOpRecovery.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {postOpRecoveryList && postOpRecoveryList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.postOpRecovery.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('recievedAt')}>
                  <Translate contentKey="tinyMedicRestApp.postOpRecovery.recievedAt">Recieved At</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('recievedAt')} />
                </th>
                <th className="hand" onClick={sort('carePlan')}>
                  <Translate contentKey="tinyMedicRestApp.postOpRecovery.carePlan">Care Plan</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('carePlan')} />
                </th>
                <th className="hand" onClick={sort('careGiven')}>
                  <Translate contentKey="tinyMedicRestApp.postOpRecovery.careGiven">Care Given</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('careGiven')} />
                </th>
                <th className="hand" onClick={sort('dischargedAt')}>
                  <Translate contentKey="tinyMedicRestApp.postOpRecovery.dischargedAt">Discharged At</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dischargedAt')} />
                </th>
                <th className="hand" onClick={sort('patientFirst')}>
                  <Translate contentKey="tinyMedicRestApp.postOpRecovery.patientFirst">Patient First</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('patientFirst')} />
                </th>
                <th className="hand" onClick={sort('sideRailsUp')}>
                  <Translate contentKey="tinyMedicRestApp.postOpRecovery.sideRailsUp">Side Rails Up</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('sideRailsUp')} />
                </th>
                <th className="hand" onClick={sort('checkMeds')}>
                  <Translate contentKey="tinyMedicRestApp.postOpRecovery.checkMeds">Check Meds</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('checkMeds')} />
                </th>
                <th className="hand" onClick={sort('frequentAssessment')}>
                  <Translate contentKey="tinyMedicRestApp.postOpRecovery.frequentAssessment">Frequent Assessment</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('frequentAssessment')} />
                </th>
                <th className="hand" onClick={sort('toiletAssist')}>
                  <Translate contentKey="tinyMedicRestApp.postOpRecovery.toiletAssist">Toilet Assist</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('toiletAssist')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.postOpRecovery.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.postOpRecovery.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.postOpRecovery.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.postOpRecovery.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.postOpRecovery.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.postOpRecovery.surgery">Surgery</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.postOpRecovery.nurse">Nurse</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {postOpRecoveryList.map((postOpRecovery, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/post-op-recovery/${postOpRecovery.id}`} color="link" size="sm">
                      {postOpRecovery.id}
                    </Button>
                  </td>
                  <td>{postOpRecovery.recievedAt}</td>
                  <td>{postOpRecovery.carePlan}</td>
                  <td>{postOpRecovery.careGiven}</td>
                  <td>{postOpRecovery.dischargedAt}</td>
                  <td>{postOpRecovery.patientFirst ? 'true' : 'false'}</td>
                  <td>{postOpRecovery.sideRailsUp ? 'true' : 'false'}</td>
                  <td>{postOpRecovery.checkMeds ? 'true' : 'false'}</td>
                  <td>{postOpRecovery.frequentAssessment ? 'true' : 'false'}</td>
                  <td>{postOpRecovery.toiletAssist ? 'true' : 'false'}</td>
                  <td>{postOpRecovery.active ? 'true' : 'false'}</td>
                  <td>{postOpRecovery.cursor}</td>
                  <td>{postOpRecovery.lastupdated}</td>
                  <td>{postOpRecovery.microSec}</td>
                  <td>{postOpRecovery.timestampentry}</td>
                  <td>
                    {postOpRecovery.surgery ? (
                      <Link to={`/patient-procedure/${postOpRecovery.surgery.id}`}>{postOpRecovery.surgery.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>{postOpRecovery.nurse ? <Link to={`/nurse/${postOpRecovery.nurse.id}`}>{postOpRecovery.nurse.id}</Link> : ''}</td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/post-op-recovery/${postOpRecovery.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/post-op-recovery/${postOpRecovery.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/post-op-recovery/${postOpRecovery.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.postOpRecovery.home.notFound">No Post Op Recoveries found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={postOpRecoveryList && postOpRecoveryList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default PostOpRecovery;
